import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    paddingVertical: 20,
    paddingHorizontal: 10,
    marginBottom: 16,
    backgroundColor: Colors.mono2,
  },
  planTitleStyle: {
    fontSize: 18,
    marginBottom: 16,
  },
  usageItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 5,
  },
  labelsStyle: {
    fontSize: 16,
  },
  divider: {
    marginVertical: 13,
    height: 1,
    width: '100%',
    backgroundColor: Colors.mono3,
  },
  monthlyCostAndTotalToPayStyle: {
    marginBottom: 25,
  },
  totalToPayAndMonthlyTextStyle: {
    ...Fonts.type.bold,
    fontSize: 16,
  },
});
